export default __webpack_public_path__ + "static/chocpops-taste-1-desktop-a5093b7b0655e90c9235b63de576fabe.png";